export default "__VITE_ASSET__DAwxUfe0__"